export default function initDialog(el: string, callback?: Function) {
    let previousFocus: any;
    let vue_app: any = null;

    const trigger_btns = document.querySelectorAll(el);
    trigger_btns.forEach((btn) => {
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();

            const id = btn.getAttribute('aria-controls');
            if (!id) {
                return;
            }
            const dialog = (document.getElementById(id) as HTMLDialogElement);
            if (!dialog) {
                return;
            }

            previousFocus = document.activeElement;

            const close = dialog.querySelector('.close');
            const closing = new CustomEvent('closing');

            dialog.addEventListener('closing', () => {
                btn.setAttribute('aria-expanded', 'false');
                if (close) {
                    close.setAttribute('aria-expanded', 'false');
                }

                dialog.setAttribute('closing', '');
                dialog.addEventListener('animationend', () => {
                    if (vue_app && (typeof vue_app.unmount === 'function')) {
                        vue_app.unmount()
                    }

                    dialog.removeAttribute('closing')
                    dialog.close();

                    if (previousFocus && (previousFocus instanceof HTMLElement)) {
                        previousFocus.focus();
                    }
                }, { once: true });
            }, { once: true });
            dialog.addEventListener('mousedown', (e) => {
                if (e.target instanceof HTMLElement) {
                    e.target.nodeName === 'DIALOG' && dialog.dispatchEvent(closing);
                }
            });

            dialog.showModal();
            btn.setAttribute('aria-expanded', 'true');
            if (close) {
                close.setAttribute('aria-expanded', 'true');
            }
            if (callback) {
                vue_app = callback();
            }

            if (close) {
                close.addEventListener('click', () => {
                    dialog.dispatchEvent(closing);
                });
            }
        });
    });
}
